import { MembershipTier } from 'types/SignUpData';

const TIER_RANK: Record<MembershipTier, number> = {
  'Tier 1': 1,
  'Tier 2': 2,
  'Tier 3': 3,
};

/** Returns true if `currentTier` meets or exceeds `requiredTier`. */
export const meetsTier = (
  currentTier: MembershipTier | undefined,
  requiredTier: MembershipTier
): boolean => {
  if (!currentTier) return false;
  return TIER_RANK[currentTier] >= TIER_RANK[requiredTier];
};